<template>
  <EsgReportsPage
    :category="category"
    :category-report="categoryReport"
    :category-report-auxiliary="categoryReportAuxiliary"
    :market="market"
    :subscription="esgSubscription"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import EsgReportsPage from '~/components/sustainability/SustainabilityTab.vue'
import type { TProduct } from '~/src/types/product'

const props = withDefaults(
  defineProps<{
    product: TProduct
    esgSubscription?: string
  }>(),
  {
    esgSubscription: '',
  },
)

const category = computed(() => props.product.category)
const categoryReport = computed(() => props.product.categoryReportEsg)
const categoryReportAuxiliary = computed(
  () => props.product.categoryReportEsgAuxiliary,
)
const market = computed(() => props.product.slug)
</script>
